import RegisterController from 'register.controller';

export default {
	templateUrl: 'src/auth/components/register/register.template.html',
	controller: RegisterController
};